import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../core/store';
import { takeUntil } from 'rxjs/operators';
import { Destroyable } from '../../../core/util/destroyable';
import { appSettings } from '../../../appSettings';
import { goAction } from '../../../core/store/router/router.actions';
import { AuthenticationService } from '../../../core/authentication/authentication.service';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends Destroyable {
  private authenticationService = inject(AuthenticationService);

  constructor(store: Store<fromRoot.RootState>) {
    super();
    this.authenticationService.authenticated$.pipe(takeUntil(this.destroyed$)).subscribe(authenticated => {
      if (authenticated) {
        store.dispatch(goAction({ path: appSettings.DEFAULT_ROUTE }));
      }
    });
  }
}
